import { NgModule } from '@angular/core';
import { NgxErrorsDirective } from './ngxerrors.directive';
import { NgxErrorDirective } from './ngxerror.directive';
var dependencies = [
    NgxErrorsDirective,
    NgxErrorDirective
];
var NgxErrorsModule = (function () {
    function NgxErrorsModule() {
    }
    return NgxErrorsModule;
}());
export { NgxErrorsModule };
NgxErrorsModule.decorators = [
    { type: NgModule, args: [{
                declarations: dependencies.slice(),
                exports: dependencies.slice()
            },] },
];
/** @nocollapse */
NgxErrorsModule.ctorParameters = function () { return []; };
//# sourceMappingURL=ngxerrors.module.js.map


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-apps-saas/~/@ultimate/ngxerrors/src/ngxerrors.module.js
// module id = ../../../../@ultimate/ngxerrors/src/ngxerrors.module.js
// module chunks = 4